export default {
  NOT_LOGGED: "Not Logged",
  LOGGED_IN: "Logged In",
  WAIT_FOR_ACCEPT_TERMS: "WAIT FOR ACCEPT TERMS",
  WAIT_FOR_SELECT_GOLFER: "WAIT FOR SELECT GOLFER",
};
